module.exports = __webpack_public_path__ + "static/media/Lato-Bold.44dfe8cc.ttf";